<p>team-member-dialog works!</p>
